import http from 'axios'
import history from './history'
import {message} from 'antd';
import gStore from 'store';

// response处理
function handleResponse(response) {
  let result;
  const responseHeaderList = [
    'application/octet-stream',
    'application/vnd.ms-excel',
    'application/vnd.ms-excel;charset=utf-8',
    'application/pdf',
    'application/json',
    'application/zip',
    'application/zip;charset=utf-8',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
  ]
  if (response.status === 401||response?.data?.code===1003) {
    // result = '会话过期，请重新登录';
    result = response?.data?.error;
    localStorage.setItem('token', '');
    localStorage.setItem('nickname', '');
    localStorage.setItem('userInfo','');
    const noErrorMsgList = ['/login','/register','/forgetPassword','/home','/goods','/business','/fqa','/goods/detail','/'];
    if (noErrorMsgList.includes(history.location.pathname)) {
      gStore.isLogin = true;
      return Promise.reject(result);
      // history.push('/login', {from: history.location})
    } else {
      result && message.error('登录过期，请重新登录');
      history.push('/login', {from: history.location})
      return Promise.reject(result)
    }
  } else if (response.status === 200) {
    if (response.data.error) {
      result = response.data.error
    } else if (response.data.hasOwnProperty('data')) {
      return Promise.resolve(response.data.data)
    } else if (responseHeaderList.includes(response.headers['content-type'])) {
      return Promise.resolve(response)
    } else if (response.data.code === 999) {
      return Promise.resolve(response)
    } else {
      return Promise.resolve(response)
    }
  } else {
    result = `请求失败: ${response.status} ${response.statusText}`
  }
  result && message.error(result);
  return Promise.reject(result)
}

// 请求拦截器
http.interceptors.request.use(request => {
  if (request.url.startsWith('/api/') || request.url.startsWith('/frontApi/') || request.url.startsWith('/javaApi/')) {
    request.headers['X-TOKEN'] = localStorage.getItem('token')
  }
  request.timeout = 3000000;
  return request;
});

// 返回拦截器
http.interceptors.response.use(response => {
  return handleResponse(response)
}, error => {
  if (error.response) {
    return handleResponse(error.response)
  }
  const result = '请求异常: ' + error.message;
  message.error(result);
  return Promise.reject(result)
});

export default http;
